import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './UserInfoHeader.styles';
import { FallbackAvatar } from './FallbackAvatar';
import type { UserInfoHeaderProps } from './UserInfoHeader.types';
import { formatUserDetailsDate } from '@/features/AdSearch/helpers';

export const UserInfoHeader = ({ user, className }: UserInfoHeaderProps) => {
  const { t } = useTranslation();

  const joinedAt = formatUserDetailsDate(user.createdAt);

  return (
    <S.Container className={className}>
      <S.Content>
        <S.AvatarBox>
          {user.photo?.url ? (
            <S.AvatarImage src={user.photo.url} alt={user.name} />
          ) : (
            <FallbackAvatar />
          )}
        </S.AvatarBox>

        <S.InfoBlock>
          <S.UserInfo>
            <S.UserName>{user.name}</S.UserName>
            <S.UserId>ID: {user.legacyId}</S.UserId>
          </S.UserInfo>

          <S.Badges>
            {user.isPhoneConfirmed && (
              <S.Badge $variant="confirmed">
                {t('pages.ads.phone_confirmed')}
              </S.Badge>
            )}
            {joinedAt && (
              <S.Badge $variant="date">
                {t('pages.ads.user_on_tap_since', { date: joinedAt })}
              </S.Badge>
            )}
          </S.Badges>
        </S.InfoBlock>
      </S.Content>
    </S.Container>
  );
};
